import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  labelText: {
    defaultMessage: 'Tink partners with MX Technologies to provide this service. ',
    id: 'Mxlabel.labelText',
  },
});
